export const documentationStyles = {
  pageContainer: {
    display: 'flex',
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 0,
  },
  breadcrumbLink: {
    textDecoration: 'none',
    color: '#0066B0',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '24px',
    letterSpacing: '0%',
    marginLeft: 30,
    marginTop: 11,
    marginBottom: 8,
  },
  documentationHeaderText: {
    fontFamily: 'Roboto',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '20px',
    lineHeight: '26px',
    letterSpacing: '0px',
    verticalAlign: 'middle',
    marginLeft: 50,
    marginBottom: 8,
  },
  documentationHeader: {
    container: {
      height: '70px',
      backgroundColor: '#FFFFFF',
      fontFamily: 'Roboto',
      fontWeight: 600,
      fontStyle: 'normal',
      fontSize: '20px',
      lineHeight: '26px',
      letterSpacing: '0px',
      verticalAlign: 'middle',
      display: 'flex',
      alignItems: 'center',
      marginLeft: '30px',
    },
    baseFontSize: 18,
  },
  mainContainer: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    alignItems: 'flex-start',
    background: '#F2F4F5',
    minHeight: 0,
    overflow: 'hidden',
  },
  leftSection: {
    outerContainer: {
      flex: 1,
    },
    container: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      minHeight: 0,
    },
    inner: {
      background: '#fff',
      color: '#222',
      borderRadius: '4px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
      width: '100%',
    },
    supportInfo: {
      margin: 0,
      fontFamily: 'Roboto, Arial, sans-serif',
      fontWeight: 600,
      fontStyle: 'normal',
      fontSize: '16px',
      lineHeight: '18px',
      letterSpacing: '0px',
      verticalAlign: 'middle',
      color: '#000000',
      marginTop: '20px',
      marginLeft: '20px',
    },
    paragraph: {
      fontFamily: 'Roboto, Arial, sans-serif',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '13px',
      lineHeight: '100%',
      letterSpacing: '0',
      color: '#737373',
      width: '750px',
      marginTop: '12px',
      marginLeft: '20px',
    },
    basePadding: 32,
  },
  rightSidebar: {
    outerContainer: {
      flexShrink: 0,
    },
    container: {
      background: '#fff',
      color: '#000',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      cursor: 'pointer',
      borderRadius: '4px',
      boxSizing: 'border-box',
      transition: 'width 0.3s ease, height 0.2s ease',
      overflowY: 'auto',
    },
    iconContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '16px 0',
      gap: '16px',
    },
    iconItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '8px 0',
      cursor: 'pointer',
    },
    iconLabel: {
      fontSize: '14px',
      display: 'block',
    },
    iconTag: {
      fontSize: '10px',
      marginTop: '4px',
      color: '#888',
      textAlign: 'center',
      maxWidth: '304px',
      whiteSpace: 'normal',
    },
    expandedLabel: {
      fontSize: '14px',
      cursor: 'pointer',
      fontWeight: 500,
    },
    newsContainer: {
      padding: '16px',
      textAlign: 'left',
      width: '100%',
    },
    newsItem: {
      marginBottom: '16px',
      borderBottom: '1px solid #eee',
      paddingBottom: '8px',
    },
    newsTag: {
      fontSize: '12px',
      color: '#0070f3',
      fontWeight: 500,
    },
    newsHeading: {
      fontSize: '15px',
      fontWeight: 600,
      margin: '2px 0',
    },
    newsLink: {
      color: '#0056b3',
      textDecoration: 'underline',
    },
    newsBrief: {
      fontSize: '13px',
      color: '#444',
    },
    baseWidth: 320,
    collapsedWidth: 48,
    basePadding: 16,
    baseFontSize: 14,
    baseHeight: 1,
    marginTop: 32,
    boxShadow: '0 0 8px rgba(0,0,0,0.08)',
  },
};
